import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceComponent } from './invoice/invoice.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from '../common/layouts/basicLayout.component';

@NgModule({
    declarations: [InvoiceComponent],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'portal',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'invoice', pathMatch: 'full' },
                    { path: 'invoice', component: InvoiceComponent, data: { title: 'Portal - Invoice', hideNav: true } }
                ]
            }
        ])
    ]
})
export class PortalModule {}
